import {useEffect, useMemo, useState} from "react";
import {correctType, getServers} from "../../../utils/legalServers";
import {TorresstreamApi} from "../../../apis/torrestream-api/torresstream-api";

export const useBestVideoServer = (item: any, file: any, type: "movie" | "tv" | string) => {
    const [selectedServer, setSelectedServer] = useState<string | null>(null);
    const [servers] = useState<any[]>(() =>
        file ? [{value: "SquadFlix", disabled: false}, ...getServers()] : getServers()
    );

    const validServers = useMemo(() => {
        return servers.filter(x => correctType(x.value, type) && !x.disabled);
    }, [servers, type]);

    const usingServer = useMemo(() => {
        return servers.find(x => x.value === selectedServer) ?? {};
    }, [servers, selectedServer]);

    useEffect(() => {
        if (!servers.length || selectedServer || !item) {
            return;
        }

        const processSetBestServer = async () => {
            if (file) {
                return "SquadFlix";
            }

            let hasTorrent = false;
            try {
                if (type === "movie") {
                    hasTorrent = await TorresstreamApi.getMovieTorrents(item.id, false).then(res => {
                        return !!res?.existingTorrents?.length;
                    });
                } else if (item?.serie?.id) {
                    hasTorrent = await TorresstreamApi.getEpisodeTorrents(
                        item.serie.id,
                        item.season_number,
                        item.episode_number,
                        false
                    ).then(res => {
                        return !!res?.existingTorrents?.length;
                    });
                }
            } catch {
                hasTorrent = false;
            }

            if (hasTorrent) {
                return "TowersStream";
            }

            return servers[0]?.value ?? null;
        };

        processSetBestServer().then(bestServer => {
            setSelectedServer(bestServer);
        });
    }, [servers, selectedServer, item, file, type]);

    return {
        servers,
        validServers,
        selectedServer,
        setSelectedServer,
        usingServer,
    };
};

export default useBestVideoServer;
